"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ProductBoxCarousel: true
};
Object.defineProperty(exports, "ProductBoxCarousel", {
  enumerable: true,
  get: function () {
    return _ProductBoxCarousel.ProductBoxCarousel;
  }
});
var _ProductBoxCarousel = require("./ProductBoxCarousel");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
